import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage, isValidUrl } from "../../../../utils/commonFunctions";
import { getEnvVar } from "../../../../envUtils";
import GroundStationService from "../../../../service/GroundStationService";
import MissionService from "../../../../service/MissionService";
import CryptoJS from 'crypto-js';
import CustomSelect from "../../../CommonComponents/CustomSelect";
import ConfirmationDialog from "../../../CommonComponents/confirmation_dialog/ConfirmationDialog";
import { showToastMessage } from "../../../../utils/commonFunctions";
import { CheckboxCheckedIcon, CheckboxUncheckedIcon } from "../../../Missions/Satellites/TestCase/svgs/TestCaseSvgs";
interface GsProviderConfigurationModalProps {
    close: (skipRefresh?: boolean) => void;
    get_gs_providers?: () => Promise<void>;
    openModal: any;
    configType?: string;
    all_providers: any[];
    all_ground_stations: any[];
}

const defaultProviderList = [
    {
        value: 'ATLAS',
        label: 'ATLAS',
        isDisabled: false,
    },
    {
        value: 'Leaf Space',
        label: 'Leaf Space',
        isDisabled: false,
    },
    {
        label: 'Antaris Gsite',
        value: 'Antaris Gsite',
        isDisabled: false,
    }
]

const GsProviderConfigurationModal: React.FC<GsProviderConfigurationModalProps> = ({ close, get_gs_providers, openModal, all_providers, all_ground_stations, configType }) => {

    const params = useParams();
    const { mission_id } = params


    const [validationErr, setValidationErr] = useState<boolean>(false)
    const [showPassword, setShowPassword] = useState<boolean | string>(false)
    const [selectedProvider, setSelectedProvider] = useState<any>(null)
    const [providerDetails, setProviderDetails] = useState<any>({})
    const [loading, setLoading] = useState<any>(false)

    const scrollRef = useRef(null)
    const [testConfig, setTestConfig] = useState<any>(false)
    const [isShowModal, setIsShowModal] = useState<any>(false)

    const getUpdatedProviderList = () => {
        if (!all_providers?.length) return defaultProviderList
        const updatedProviderList = defaultProviderList.map((item) => {
            const isUsed = all_providers.some(
                (provider: any) =>
                    !provider?.IsAntarisGsiteProvider &&
                    provider?.providerName === item.label
            );

            return {
                ...item,
                isDisabled: isUsed,
            };
        });
        return updatedProviderList
    }
    const providerOptions = useMemo(() => getUpdatedProviderList(), [all_providers, defaultProviderList])

    const check_validation = () => {
        if (!providerDetails?.['providerName'] || providerDetails?.['providerName'] === '' || (providerDetails?.['providerName'] && providerDetails?.['providerName'].toLowerCase().includes('untitled'))) {
            showToastMessage('info', providerDetails?.['providerName'].toLowerCase().includes('untitled') ? `Provider name can't contain the word "untitled"` : 'Provider name is required')
            return true
        } else if (!providerDetails?.['APIEndpoint'] || providerDetails?.['APIEndpoint'] === '' || !isValidUrl(providerDetails?.['APIEndpoint'])) {
            const message = !isValidUrl(providerDetails?.['APIEndpoint']) ? 'API Endpoint must be a valid URL' : 'API Endpoint is required'
            showToastMessage('info', message)
            return true
        } else if (!providerDetails?.['APIUsername'] || providerDetails?.['APIUsername'] === '') {
            showToastMessage('info', 'Username is required for API Endpoint')
            return true
        } else if (!providerDetails?.['APIPassword'] || providerDetails?.['APIPassword'] === '') {
            showToastMessage('info', 'Password is required for API Endpoint')
            return true
        } else if (!providerDetails?.['MQTTEndpoint'] || providerDetails?.['MQTTEndpoint'] === '' || !isValidUrl(providerDetails?.['MQTTEndpoint'])) {
            const message = !isValidUrl(providerDetails?.['MQTTEndpoint']) ? 'MQTT Endpoint must be a valid URL' : 'MQTT Endpoint is required'
            showToastMessage('info', message)
            return true
        } else if (!providerDetails?.['MQTTUsername'] || providerDetails?.['MQTTUsername'] === '') {
            showToastMessage('info', 'Username is required for MQTT Endpoint')
            return true
        } else if (!providerDetails?.['MQTTPassword'] || providerDetails?.['MQTTPassword'] === '') {
            showToastMessage('info', 'Password is required for MQTT Endpoint')
            return true
        } else if (testConfig && (!providerDetails?.['TestAPIEndpoint'] || providerDetails?.['TestAPIEndpoint'] === '' || !isValidUrl(providerDetails?.['TestAPIEndpoint']))) {
            showToastMessage('info', !isValidUrl(providerDetails?.['TestAPIEndpoint']) ? 'Test API Endpoint must be a valid URL' : 'Test API Endpoint is required')
            return true
        } else if (testConfig && (!providerDetails?.['TestAPIUsername'] || providerDetails?.['TestAPIUsername'] === '')) {
            showToastMessage('info', 'Username is required for Test API Endpoint')
            return true
        } else if (testConfig && (!providerDetails?.['TestAPIPassword'] || providerDetails?.['TestAPIPassword'] === '')) {
            showToastMessage('info', 'Password is required for Test API Endpoint')
            return true
        } else if (testConfig && (!providerDetails?.['TestMQTTEndpoint'] || providerDetails?.['TestMQTTEndpoint'] === '' || !isValidUrl(providerDetails?.['TestMQTTEndpoint']))) {
            showToastMessage('info', !isValidUrl(providerDetails?.['TestMQTTEndpoint']) ? 'Test MQTT Endpoint must be a valid URL' : 'Test MQTT Endpoint is required')
            return true
        } else if (testConfig && (!providerDetails?.['TestMQTTUsername'] || providerDetails?.['TestMQTTUsername'] === '')) {
            showToastMessage('info', 'Username is required for Test MQTT Endpoint')
            return true
        } else if (testConfig && (!providerDetails?.['TestMQTTPassword'] || providerDetails?.['TestMQTTPassword'] === '')) {
            showToastMessage('info', 'Password is required for Test MQTT Endpoint')
            return true
        } else {
            return false
        }
    }

    const encrypt = (password) => {
        let secret = getEnvVar('REACT_APP_SECRET_KEY')
        var encrypted = CryptoJS.AES.encrypt(password, secret).toString();
        return encrypted;
    }

    const decrypt = (encryptedData) => {
        let secret = getEnvVar('REACT_APP_SECRET_KEY')
        var bytes = CryptoJS.AES.decrypt(encryptedData, secret);
        var decrypted = bytes.toString(CryptoJS.enc.Utf8);
        return decrypted;
    };
    // utils/inputValidation.ts

    const handleValidatedInputChange = (
        field: string,
        value: string,
        setProviderDetails: (val: any) => void,
        providerDetails: any,
        setLoading: (val: boolean) => void,
        maxLength: number = 26
    ) => {
        if (!containsSpecialChars(value) && value.trim().length <= maxLength) {
            setLoading(false);
            setProviderDetails({
                ...providerDetails,
                [field]: value.trim(),
            });
        } else {
            if (containsSpecialChars(value)) {
                showToastMessage("info", getSpecialCharacterMessage());
            } else {
                showToastMessage("info", getCharacterLimitMessage(maxLength));
            }
        }
    };

    const handleEndpointChange = (field: string, value: string) => {
        if (value.trim().length > 100) {
            showToastMessage('info', getCharacterLimitMessage(100))
        } else {
            setProviderDetails({
                ...providerDetails,
                [field]: value.trim()
            })
        }
    };

    useEffect(() => {
        if (openModal?.['mode'] === 'Update') {
            let hash_passwords: any = {}
            if (openModal?.['data']?.['APIEndpoint']) {
                if (openModal?.['data']?.['TestAPIEndpoint']) {
                    hash_passwords = {
                        APIPassword: openModal?.['data']?.['APIPassword'],
                        MQTTPassword: openModal?.['data']?.['MQTTPassword'],
                        TestAPIPassword: openModal?.['data']?.['APIPassword'],
                        TestMQTTPassword: openModal?.['data']?.['MQTTPassword'],
                    }
                } else {
                    hash_passwords = {
                        APIPassword: openModal?.['data']?.['APIPassword'],
                        MQTTPassword: openModal?.['data']?.['MQTTPassword']
                    }
                }
            }
            setProviderDetails(Object.keys(hash_passwords)?.length > 0 ? {
                ...openModal?.['data'],
                ...hash_passwords
            } : {
                ...openModal?.['data'],
            })
            setSelectedProvider(openModal?.['data']?.['IsAntarisGsiteProvider'] ? { label: 'Antaris Gsite', value: 'Antaris Gsite', } : { label: openModal?.['data']?.['providerName'], value: openModal?.['data']?.['providerName'] })

            if (configType === 'add_test_configuration') {
                setTestConfig(true)
            } else {
                setTestConfig(openModal?.['data']?.['TestAPIEndpoint'] ? true : false)
            }
        }
    }, [openModal])

    const create_new_provider = async (provider: any) => {
        const updated_provider = {
            ...provider,
            'providerName': provider?.['providerName']?.trimEnd()
        };
        try {
            const res = await GroundStationService.createGsProvider(updated_provider);
            if (res) {
                if (get_gs_providers) {
                    await get_gs_providers();
                }
                setLoading(false);
                showToastMessage('success', 'GS Provider created successfully');
                close(true);
            }
        } catch (err: any) {
            setLoading(false);
            console.error(err);
        }
    }

    const update_mission_ground_stations = (providers) => {
        let updated_mission_ground_stations: any = []
        providers?.map((provider: any) => {
            updated_mission_ground_stations = updated_mission_ground_stations?.length > 0 ? [...updated_mission_ground_stations, ...provider?.groundStations] : [...provider?.groundStations]
        })

        MissionService.updateMissionStations(mission_id, updated_mission_ground_stations)?.then((res) => {
            if (res?.data) {
                showToastMessage('success', `GS Provider updated successfully`)
            }
        }).catch((err) => {
            console.error(err);
            showToastMessage('error', 'Failed to update station')
        })

    }

    const update_existing_provider = async (provider: any) => {
        const updated_provider = {
            ...provider,
            'providerName': provider?.['providerName']?.trimEnd()
        };
        let filter_providers = all_providers?.filter((item: any) => item?.['uniqueId'] !== provider?.['uniqueId']);
        let providers_list = [...filter_providers, updated_provider];
        try {
            const res = await GroundStationService.updateGsProvider(provider?.['uniqueId'], updated_provider);
            if (res) {
                await update_ground_station(updated_provider);
                if (get_gs_providers) {
                    await get_gs_providers();
                }
                setLoading(false);
                showToastMessage('success', 'GS Provider updated successfully');
                close(true);
                // This commented code may use in future
                // update_mission_ground_stations(providers_list)
            }
        } catch (err: any) {
            setLoading(false);
            console.error(err);
        }
    }

    const update_ground_station = async (provider: any) => {
        let provider_associated_gs = all_ground_stations?.filter((station: any) => provider?.['groundStations'] && provider?.['groundStations']?.includes(station?.['groundStationId']));
        let updated_provider_associated_gs: any = [];
        provider_associated_gs?.map((station: any) => {
            if (station?.['owner-org'] !== "System") {
                let data = {
                    ...station,
                    properties: {
                        ...station?.['properties'],
                        provider: provider?.['providerName'],
                    },
                    status: station?.['status']
                };
                updated_provider_associated_gs = [...updated_provider_associated_gs, data];
            }
        });
        if (updated_provider_associated_gs?.length > 0) {
            try {
                const res = await GroundStationService.updateGroundStations(updated_provider_associated_gs);
                if (res?.data) {
                    // Success - continue
                }
            } catch (err: any) {
                console.error(err);
                showToastMessage('error', 'Something went wrong while updating ground stations');
                setLoading(false);
            }
        }
    }

    const handle_submit_form = async () => {
        let validation = check_validation()
        if (validation) {
            setValidationErr(true)
        } else {
            setLoading(true)
            setValidationErr(false)
            let not_configured_provider_stations = all_ground_stations?.filter(station => providerDetails?.['groundStations'] && providerDetails?.['groundStations']?.includes(station?.['groundStationId']) && station?.['status'] === 'Configure')

            let hash_passwords: any = {}
            if (!testConfig) {
                Object.keys(providerDetails).map(async (key: any) => {
                    if (key.includes('Test')) {
                        delete providerDetails[key]
                    }
                })
                hash_passwords = {
                    APIPassword: providerDetails?.['APIPassword'],
                    MQTTPassword: providerDetails?.['MQTTPassword']
                }
            } else {
                hash_passwords = {
                    APIPassword: providerDetails?.['APIPassword'],
                    MQTTPassword: providerDetails?.['MQTTPassword'],
                    TestAPIPassword: providerDetails?.['APIPassword'],
                    TestMQTTPassword: providerDetails?.['MQTTPassword'],
                }
            }

            let data = {
                ...providerDetails,
                ...hash_passwords,
                missionId: mission_id,
                mqttConfiguredBands: providerDetails?.['mqttConfiguredBands'] ? providerDetails?.['mqttConfiguredBands'] : [],
                uniqueId: openModal?.['mode'] === 'Update' ? providerDetails?.['uniqueId'] : uuidv4(),
                nextConfigStep: (!providerDetails?.['MQTTEndpoint'] || providerDetails?.['MQTTEndpoint'] === '') ? 'Configure Provider' : (!providerDetails?.['groundStations'] || providerDetails?.['groundStations']?.length === 0) ? 'Add Ground Station' : not_configured_provider_stations?.length > 0 ? 'Configure Ground Station' : (!providerDetails?.['MQTTTopicList'] || providerDetails?.['MQTTTopicList']?.length === 0) ? 'Configure MQTT Topics' : '',
                status: ((!providerDetails?.['MQTTEndpoint'] || providerDetails?.['MQTTEndpoint'] === '') || (!providerDetails?.['groundStations'] || providerDetails?.['groundStations']?.length === 0) || (!providerDetails?.['MQTTTopicList'] || providerDetails?.['MQTTTopicList']?.length === 0)) ? 'Not Configured' : 'Configured',
            }

            if (openModal?.['mode'] === 'Update') {
                update_existing_provider(data)
            } else {
                create_new_provider(data)
            }
        }
    }

    const scroll_to_bottom = () => {
        const container = scrollRef.current;
        if (container) {
            (container as HTMLElement).scrollTop = (container as HTMLElement).scrollHeight;
            (container as HTMLElement).scrollIntoView({ behavior: 'smooth' });
        }
    }

    const provider_exist = () => {
        let name_exist = false
        if (openModal?.['mode'] === 'Create') {
            let filter_providers = all_providers.filter((provider: any) => provider?.['uniqueId'] !== providerDetails?.['uniqueId'])

            filter_providers.map((provider: any) => {
                if (provider?.['providerName'] === providerDetails?.['providerName']) {
                    name_exist = true
                } else if (providerDetails?.['IsAntarisGsiteProvider'] === true && (providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'atlas' || providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'leafspace')) {
                    name_exist = true
                }
            })
        } else if (openModal?.['mode'] === 'Update') {
            all_providers.map((provider: any) => {
                if (providerDetails?.['IsAntarisGsiteProvider'] === true && (providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'atlas' || providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'leafspace')) {
                    name_exist = true
                }
            })
        }

        return name_exist
    }

    useEffect(() => {
        const container = scrollRef.current;
        if (!providerDetails?.['TestAPIEndpoint'] && testConfig && container) {
            (container as HTMLElement).scrollTop = (container as HTMLElement).scrollHeight;
            (container as HTMLElement).scrollIntoView({ behavior: 'smooth' });
        }
    }, [openModal, testConfig, scrollRef])

    const toggle_test_config = () => {
        if (!testConfig) {
            if (Object.keys(providerDetails).length === 0) {
                setTestConfig(false)
                setValidationErr(true)
            } else {
                Object.keys(providerDetails).map((key: any) => {
                    if (!key.includes('Test') && providerDetails[key] === '') {
                        setTestConfig(false)
                        setValidationErr(true)
                    } else {
                        setTestConfig(true)
                        setValidationErr(false)
                    }
                })
            }
        } else {
            setTestConfig(false)
        }
    }


    return (
        <div className='popup-model z-2'>
            <div className='model-md gap-3 p-0'>
                <div className='w-100 d-flex justify-content-between align-items-center px-5 pt-5'>
                    <span className='form-heade-text fs-18' > Ground Station Provider</span>
                    <i onClick={() => { setIsShowModal(true) }} className="fe fe-x-circle me-1 fs-25 cursor-pointer text-white"></i>
                </div>

                <div className="modal_devider" />

                <Form autoComplete="off" validated={validationErr} className={`d-flex flex-column gap-3 transition-height pop-scroll-md px-5 pb-5`} ref={scrollRef}>
                    <div className={`w-100 d-flex gap-4 align-items-center ${openModal?.['mode'] === 'Update' ? 'opacity-50' : ''}`}>
                        <span>Ground Station Provider *</span>
                        <div className="d-flex w-70 flex-column gap-2">
                            <CustomSelect
                                isDisabled={openModal?.['mode'] === 'Update'}
                                options={providerOptions}
                                placeholder="Select Provider"
                                value={selectedProvider}
                                onChange={(e: any) => {
                                    setSelectedProvider(e)
                                    setProviderDetails({
                                        ...providerDetails,
                                        providerName: e.value !== 'Antaris Gsite' ? e.value : '',
                                        IsAntarisGsiteProvider: e.value === 'Antaris Gsite' ? true : false
                                    })
                                }}

                            />
                            <Form.Control.Feedback type="invalid">Provider is required.</Form.Control.Feedback>
                        </div>
                    </div>

                    <div className="modal_devider" />

                    <Fragment>
                        <Fragment>
                            {providerDetails?.['IsAntarisGsiteProvider'] && (
                                <div className="w-100 d-flex flex-column gap-2 w-100">
                                    <span>Antaris GSite Provider Name *</span>
                                    <Form.Control className="w-100" placeholder="Enter Provider Name"
                                        required
                                        value={providerDetails?.['providerName']}
                                        onChange={(e) => {
                                            handleValidatedInputChange(
                                                "providerName",
                                                e.target.value,
                                                setProviderDetails,
                                                providerDetails,
                                                setLoading
                                            )
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">Provider name is required.</Form.Control.Feedback>
                                </div>
                            )}
                            <div className="w-100 d-flex flex-column gap-2">
                                <span>API Endpoint *</span>
                                <Form.Control className="w-100" placeholder={`Enter API Endpoint`}
                                    required
                                    value={providerDetails?.['APIEndpoint'] ? providerDetails?.['APIEndpoint'] : ''}
                                    disabled={!selectedProvider}
                                    onChange={(e) => handleEndpointChange('APIEndpoint', e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">API Endpoint is required</Form.Control.Feedback>
                            </div>

                            <div className="d-flex w-100 gap-3 align-items-center">
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Username *</span>
                                    <Form.Control
                                        autoComplete="off"
                                        className="w-100"
                                        placeholder={`Enter Username`}
                                        name="APIUsername"
                                        required
                                        value={providerDetails?.['APIUsername'] ? providerDetails?.['APIUsername'] : ''}
                                        disabled={!selectedProvider}
                                        onChange={(e) => {
                                            handleValidatedInputChange(
                                                "APIUsername",
                                                e.target.value,
                                                setProviderDetails,
                                                providerDetails,
                                                setLoading
                                            )
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">Username is required</Form.Control.Feedback>
                                </div>
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Password *</span>
                                    <div className="w-100 d-flex flex-column gap-2 position-relative justify-content-center">
                                        {/* {providerDetails?.['APIPassword'] && providerDetails?.['APIPassword'] !== '' &&
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setShowPassword(showPassword === 'APIPassword' ? false : 'APIPassword')
                                                }}
                                                className="btn-close bg-light-black right-0 d-flex align-items-center p-1 px-2 justify-content-center position-absolute">
                                                <i className={`fe ${showPassword === 'APIPassword' ? 'fe-eye-off' : 'fe-eye'} text-white fs-18`} />
                                            </button>
                                        } */}
                                        <Form.Control
                                            autoComplete="new-password"
                                            className="w-100"
                                            placeholder={`Enter Password`}
                                            type={showPassword === 'APIPassword' ? 'text' : 'password'}
                                            required
                                            name="APIPassword"
                                            disabled={!selectedProvider}
                                            minLength={1}
                                            value={providerDetails?.['APIPassword'] ? providerDetails?.['APIPassword'] : ''}
                                            onChange={(e) => {
                                                setProviderDetails({
                                                    ...providerDetails,
                                                    APIPassword: e.target.value.trim()
                                                })
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">Password field can not be empty.</Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                        </Fragment>

                        <Fragment>
                            <div className="w-100 d-flex flex-column gap-2">
                                <span>MQTT Endpoint *</span>
                                <Form.Control className="w-100" placeholder={`Enter MQTT Endpoint`}
                                    required
                                    value={providerDetails?.['MQTTEndpoint'] ? providerDetails?.['MQTTEndpoint'] : ''}
                                    disabled={!selectedProvider}
                                    onChange={(e) => handleEndpointChange('MQTTEndpoint', e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">MQTT Endpoint is required</Form.Control.Feedback>
                            </div>

                            <div className="d-flex w-100 gap-3 align-items-center">
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Username *</span>
                                    <Form.Control
                                        autoComplete="off"
                                        className="w-100"
                                        placeholder={`Enter Username`}
                                        name="MQTTUsername"
                                        required
                                        disabled={!selectedProvider}
                                        value={
                                            providerDetails?.['MQTTUsername'] ? providerDetails?.['MQTTUsername'] : ''
                                        }
                                        onChange={(e) => {
                                            handleValidatedInputChange(
                                                "MQTTUsername",
                                                e.target.value,
                                                setProviderDetails,
                                                providerDetails,
                                                setLoading
                                            )
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">Username is required</Form.Control.Feedback>
                                </div>
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Password *</span>
                                    <div className="w-100 d-flex flex-column gap-2 position-relative justify-content-center">
                                        {/* {providerDetails?.['MQTTPassword'] && providerDetails?.['MQTTPassword'] !== '' &&
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    setShowPassword(showPassword === 'MQTTPassword' ? false : 'MQTTPassword')
                                                }}
                                                className="btn-close bg-light-black right-0 d-flex align-items-center p-1 px-2 justify-content-center position-absolute">
                                                <i className={`fe ${showPassword === 'MQTTPassword' ? 'fe-eye-off' : 'fe-eye'} text-white fs-18`} />
                                            </button>
                                        } */}
                                        <Form.Control
                                            autoComplete="new-password"
                                            className="w-100"
                                            placeholder={`Enter Password`}
                                            name="MQTTPassword"
                                            type={showPassword === 'MQTTPassword' ? 'text' : 'password'}
                                            required
                                            disabled={!selectedProvider}
                                            minLength={1}
                                            value={providerDetails?.['MQTTPassword'] ? providerDetails?.['MQTTPassword'] : ''}
                                            onChange={(e) => {
                                                setProviderDetails({
                                                    ...providerDetails,
                                                    MQTTPassword: e.target.value.trim()
                                                })
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">Password field can not be empty.</Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    </Fragment>

                    <div className="d-flex w-100 justify-content-end align-items-center gap-2">
                        <button
                            type="button"
                            onClick={() => {
                                toggle_test_config()
                                scroll_to_bottom()
                            }}
                            disabled={!selectedProvider}
                            className="bg-transparent border-0 p-0 d-flex align-items-center cursor-pointer"
                            style={{ width: '20px' }}
                        >
                            {testConfig ? <CheckboxCheckedIcon /> : <CheckboxUncheckedIcon />}
                        </button>
                        <label className="mb-0 cursor-pointer mt-0">Add Test Configuration</label>
                    </div>

                    {testConfig &&
                        <Fragment>
                            <Fragment>
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Test API Endpoint *</span>
                                    <Form.Control className="w-100" placeholder={`Enter Test API Endpoint`}
                                        required
                                        value={providerDetails?.['TestAPIEndpoint'] ? providerDetails?.['TestAPIEndpoint'] : ''}
                                        onChange={(e) => handleEndpointChange('TestAPIEndpoint', e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">Test API Endpoint is required</Form.Control.Feedback>
                                </div>

                                <div className="d-flex w-100 gap-3 align-items-center">
                                    <div className="w-100 d-flex flex-column gap-2">
                                        <span>Username *</span>
                                        <Form.Control
                                            autoComplete="off"
                                            className="w-100"
                                            placeholder={`Enter Username`}
                                            name="TestAPIUsername"
                                            required
                                            value={providerDetails?.['TestAPIUsername'] ? providerDetails?.['TestAPIUsername'] : ''}
                                            onChange={(e) => {
                                                handleValidatedInputChange(
                                                    "TestAPIUsername",
                                                    e.target.value,
                                                    setProviderDetails,
                                                    providerDetails,
                                                    setLoading
                                                )
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">Username is required</Form.Control.Feedback>
                                    </div>
                                    <div className="w-100 d-flex flex-column gap-2">
                                        <span>Password *</span>
                                        <div className="w-100 d-flex flex-column gap-2 position-relative justify-content-center">
                                            {/* {providerDetails?.['TestAPIPassword'] && providerDetails?.['TestAPIPassword'] !== '' &&
                                                <button
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        setShowPassword(showPassword === 'TestAPIPassword' ? false : 'TestAPIPassword')
                                                    }}
                                                    className="btn-close bg-light-black right-0 d-flex align-items-center p-1 px-2 justify-content-center position-absolute">
                                                    <i className={`fe ${showPassword === 'TestAPIPassword' ? 'fe-eye-off' : 'fe-eye'} text-white fs-18`} />
                                                </button>
                                            } */}
                                            <Form.Control
                                                autoComplete="new-password"
                                                className="w-100"
                                                placeholder={`Enter Password`}
                                                name="TestAPIPassword"
                                                type={showPassword === 'TestAPIPassword' ? 'text' : 'password'}
                                                required
                                                minLength={1}
                                                value={providerDetails?.['TestAPIPassword'] ? providerDetails?.['TestAPIPassword'] : ''}
                                                onChange={(e) => {
                                                    setProviderDetails({
                                                        ...providerDetails,
                                                        TestAPIPassword: e.target.value.trim()
                                                    })
                                                }}
                                            />
                                            <Form.Control.Feedback type="invalid">Password field can not be empty.</Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>

                            <Fragment>
                                <div className="w-100 d-flex flex-column gap-2">
                                    <span>Test MQTT Endpoint *</span>
                                    <Form.Control className="w-100" placeholder={`Enter Test MQTT Endpoint`}
                                        required
                                        value={providerDetails?.['TestMQTTEndpoint'] ? providerDetails?.['TestMQTTEndpoint'] : ''}
                                        onChange={(e) => handleEndpointChange('TestMQTTEndpoint', e.target.value)}
                                    />
                                    <Form.Control.Feedback type="invalid">Test MQTT Endpoint is required</Form.Control.Feedback>
                                </div>

                                <div className="d-flex w-100 gap-3 align-items-center">
                                    <div className="w-100 d-flex flex-column gap-2">
                                        <span>Username *</span>
                                        <Form.Control
                                            autoComplete="off"
                                            className="w-100"
                                            placeholder={`Enter Username`}
                                            name="TestMQTTUsername"
                                            required
                                            value={
                                                providerDetails?.['TestMQTTUsername'] ? providerDetails?.['TestMQTTUsername'] : ''
                                            }
                                            onChange={(e) => {
                                                handleValidatedInputChange(
                                                    "TestMQTTUsername",
                                                    e.target.value,
                                                    setProviderDetails,
                                                    providerDetails,
                                                    setLoading
                                                )
                                            }}
                                        />
                                        <Form.Control.Feedback type="invalid">Username is required</Form.Control.Feedback>
                                    </div>
                                    <div className="w-100 d-flex flex-column gap-2">
                                        <span>Password *</span>
                                        <div className="w-100 d-flex flex-column gap-2 position-relative justify-content-center">
                                            {/* {providerDetails?.['TestMQTTPassword'] && providerDetails?.['TestMQTTPassword'] !== '' &&
                                                <button
                                                    onClick={(e: any) => {
                                                        e.preventDefault()
                                                        setShowPassword(showPassword === 'TestMQTTPassword' ? false : 'TestMQTTPassword')
                                                    }}
                                                    className="btn-close bg-light-black right-0 d-flex align-items-center p-1 px-2 justify-content-center position-absolute">
                                                    <i className={`fe ${showPassword === 'TestMQTTPassword' ? 'fe-eye-off' : 'fe-eye'} text-white fs-18`} />
                                                </button>
                                            } */}
                                            <Form.Control
                                                autoComplete="new-password"
                                                className="w-100"
                                                placeholder={`Enter Password`}
                                                name="TestMQTTPassword"
                                                type={showPassword === 'TestMQTTPassword' ? 'text' : 'password'}
                                                required
                                                minLength={1}
                                                value={providerDetails?.['TestMQTTPassword'] ? providerDetails?.['TestMQTTPassword'] : ''}
                                                onChange={(e: any) => {
                                                    setProviderDetails({
                                                        ...providerDetails,
                                                        TestMQTTPassword: e.target.value.trim()
                                                    })
                                                }}
                                            />
                                            <Form.Control.Feedback type="invalid">Password field can not be empty.</Form.Control.Feedback>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        </Fragment>
                    }
                </Form>
                <div className="modal_devider" />
                <div className="w-100 d-flex justify-content-between align-items-center mt-3 px-5 pb-5">
                    <button disabled={loading} onClick={() => { setIsShowModal(true) }} className="btn btn-outline-cancel">Cancel</button>
                    <button disabled={!selectedProvider || loading || Object.keys(providerDetails)?.length === 0} onClick={() => {
                        let name_exist = false
                        if (all_providers?.length > 0) {
                            name_exist = provider_exist()
                        } else if (providerDetails?.['IsAntarisGsiteProvider'] === true && (providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'atlas' || providerDetails?.['providerName'].toLowerCase().replace(/\s/g, "") === 'leafspace') || providerDetails?.['providerName'].toLowerCase().includes('untitled')) {
                            name_exist = true
                        }
                        if (name_exist) {
                            showToastMessage('error', providerDetails?.['providerName'].toLowerCase().includes('untitled') ? 'Provider name cannot be "Untitled"' : 'Provider name already exists')
                        } else {
                            handle_submit_form()
                        }
                    }} className="btn btn-primary">{openModal?.['mode'] === 'Create' ? 'Save' : 'Update'}</button>
                </div>
            </div>

            <ConfirmationDialog
                type='cancel'
                open={isShowModal ? true : false}
                title={`Discard GS Provider Configuration?`}
                description={`Discarding provider configuration flow will take you back to the list of providers.`}
                onCancel={() => setIsShowModal(false)}
                onConfirm={() => {
                    close()
                    setIsShowModal(false);
                }}
                confirm_button_text={`Discard`}
            />
        </div>
    )
}

export default GsProviderConfigurationModal